<template>
  <div class="report-page row-block" :style="{ minHeight: minHeight }">
    <div class="filter-container" :style="{ width: '250px' }">
      <reportFilter
        :minHeight="minHeight"
        :disabled="false"
        :title="'分析報告搜尋'"
        :filters="{
          init: init,
          options: filterOptions
        }"
        @changeFilters="(c, search) => { filters = c; search && searchDatas(c) }"
      ></reportFilter>
    </div>
    <div class="main-container row-block" :style="{ flex: 1, height: minHeight }">
      <div v-if="onSearch" class="mask center-block" :style="{ height: '100%', width: '100%', 'min-width': '1000px' }">
        <!-- <img :src="require('../../assets/images/loading.gif')"> -->
        <img :src="require('../../assets/images/upload.svg')" alt="">
      </div>
      <div ref="report-main" class="main-block col-block" :style="{ height: '100%', width: '100%', 'min-width': '1000px' }">
        <div class="report-container col-block" :style="{ flex: 1, height: 0 }">
          <div class="report-field-container row-block stretch">
            <div class="report-field" v-for="(report, index) in reports.concat((new Array(reportBlock.fillCount)).fill({}))" :key="index">
              <div v-if="report.id" class="report-block default-shadow col-block" :style="{ width: reportBlock.width + 'px' }">
                <div class="cover-container">
                  <div class="cover-block center-block" @click="e => reportDetail(report)">
                    <img :src="report.cover_photo_url || require('../../assets/images/report-default-cover.jpeg')" alt="">
                  </div>
                </div>
                <div class="content-container col-block">
                  <div class="date">{{ '發表時間：' + getDateCompare(new Date(report.publish_time)) }}</div>
                  <div :style="{ height: '10px' }"></div>
                  <div class="title">{{ report.title.substring(0, 25) + (report.title.length > 25 ? '...' : '') }}</div>
                  <div :style="{ height: '10px' }"></div>
                  <div class="content">{{ report.content ? htmlDecode((report.content).replace(/\<.+?\>/g, '')).substring(0, 55) + (htmlDecode((report.content).replace(/\<.+?\>/g, '')).length > 55 ? '...' : '') : '沒有文字內容' }}</div>
                  <div :style="{ height: '10px' }"></div>
                  <div class="option row-block">
                    <div class="detail" @click="e => reportDetail(report)">更多內容</div>
                    <div class="comment row-block">
                      <img :src="require('../../assets/images/report-comment-icon.svg')" alt="">
                      <div :style="{ width: '5px' }"></div>
                      <div class="count">{{ report.comments_count }}</div>
                    </div>
                  </div>
                  <div :style="{ height: '10px' }"></div>
                  <div class="tags row-block">
                    <div class="tag-field" v-for="(tag, tindex) in getReportTags(report)" :key="tindex">
                      <div class="tag-block">
                        <div class="tag-title" @click="e => setFilter(tag.filter)">{{ tag.title + ',' }}</div>
                      </div>
                    </div>
                  </div>
                  <div :style="{ flex: 1 }"></div>
                </div>
                <div :style="{ flex: 1 }"></div>
              </div>
              <div v-else class="report-block empty" :style="{ width: reportBlock.width + 'px' }">
              </div>
            </div>
          </div>
          <div :style="{ flex: 1 }"></div>
        </div>
        <div class="page-container center-block">
          <pageButtons
            v-if="pageData.total"
            :default="pageData.selectedPage"
            :display="pageData.display"
            :total="pageData.total"
            :buttonRange="pageData.buttonRange"
            @selectPage="page => { pageData.selectedPage = page; searchDatas() }"
          ></pageButtons>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { getProductByCategorys, getReports } from '../../api'
import reportFilter from '../../components/report/filter'
import pageButtons from '../../components/tool/pageButtons'
import routeLoading from '../../mixins/routeLoading'
import toastMethods from '../../mixins/toastMethods'
import { dateFormat, htmlDecode } from '../../constants/global/util'

export default {
  components: {
    reportFilter,
    pageButtons
  },
  mixins: [
    routeLoading,
    toastMethods
  ],
  props: {
    minHeight: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      reports: [],
      productByCategorys: [],
      init: {},
      filters: {},
      onSearch: false,
      pageData: {
        selectedPage: 1,
        display: 12,
        total: null,
        buttonRange: 7
      },
      sort: {
        value: ['publish_time'],
        order: ['desc']
      },
      reportBlock: {
        width: 300,
        fillCount: 0
      }
    }
  },
  computed: {
    ...mapGetters([
      'countrys'
    ]),
    categoryOptions () {
      return [
        ...Object.keys(this.productByCategorys).map(category => ({ title: category, value: category })),
        { title: '其他', value: '其他' }
      ]
    },
    productOptions () {
      return [
        ...Array.prototype.concat.apply([], Object.entries(this.productByCategorys).map(([category, products]) => Object.entries(products).map(([code, product]) => ({ title: product.chinese_name + '(' + code + ')', value: code, type: product.product_type, category: category })))),
        { title: '其他', value: '其他', type: '其他', category: '其他' }
      ]
    },
    moduleOptions () {
      return [
        { title: '市場吸引力', value: 'market_attractiveness' },
        { title: '市場競爭力', value: 'market_competitiveness' },
        { title: '零售價格分析', value: 'product_prices' },
        { title: '其他', value: 'others' }
      ]
    },
    yearOptions () {
      let year = (new Date()).getFullYear()
      return [
        { title: '無', value: '無' },
        ...(new Array(year - 2000)).fill('').map((_, i) => ({ title: year - i + '', value: year - i + '' }))
      ]
    },
    countryOptions () {
      return this.countrys.map(([key, value]) => ({
        title: value.chinese_name + '(' + value.iso_name + ')',
        value: key,
        country: value
      }))
    },
    // static
    filterOptions () {
      return [
        {
          title: '標題關鍵字',
          value: 'title',
          type: 'input',
          options: this.kindOptions,
          placeholder: () => '如：產業報告...等'
        },
        {
          title: '產品類別',
          value: 'category',
          type: 'select',
          options: this.categoryOptions,
          placeholder: () => '水果、蔬菜、農業機械...等',
          onChange: (value, conditions) => {
            setTimeout(() => {
              this.init = {
                ...this.init,
                ...conditions,
                product_code: ''
              }
            })
          }
        },
        {
          title: '產品名稱',
          value: 'product_code',
          type: 'select',
          options: this.productOptions,
          optionDisplay: result => option => option.category === result.category,
          placeholder: () => '請選擇產品'
        },
        {
          title: '國家',
          value: 'countries',
          type: 'datalist',
          lists: value => this.countryOptions.map(option => option.title),
          options: this.countryOptions,
          placeholder: () => '請選擇國家',
          onChange: value => {
            if (value && !this.countryOptions.some(option => option.title === value)) {
              this.init = {
                ...this.init,
                ...this.filters,
                countries: ''
              }
            }
          }
        },
        {
          title: '分析模組',
          value: 'module',
          type: 'select',
          options: this.moduleOptions,
          placeholder: () => '請選擇分析模組'
        },
        {
          title: '年份',
          value: 'year',
          type: 'select',
          options: this.yearOptions,
          placeholder: () => '請選擇年份'
        }
      ]
    },
    // global
    htmlDecode () { return htmlDecode }
  },
  beforeMount () {
    window.addEventListener('resize', this.onWindowResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onWindowResize)
  },
  watch: {
    'reports.length' () {
      this.onWindowResize()
    }
  },
  methods: {
    ...mapActions([
      'setLoadingAction',
      'setModalAction'
    ]),
    async fetchData () {
      await this.fetchProductByCategorys()
      await this.fetchReports()
    },
    async fetchProductByCategorys () {
      try {
        let config = this.$ls.get('userInfo')
        let response = await getProductByCategorys(config)
        let productByCategorys = response.data
        this.productByCategorys = productByCategorys
      } catch (error) {
        throw error
      }
    },
    async fetchReports (filters) {
      try {
        let config = this.$ls.get('userInfo')
        filters = filters || this.filters || {}
        let data = {
          ...Object.entries(filters).filter(kv => kv[1]).reduce((s, kv) => ({ ...s, [kv[0]]: kv[1] }), {}),
          year: filters.year === '無' ? '' : (filters.year || null),
          product_code: filters.product_code === '其他' ? '' : (filters.product_code || null),
          countries: (this.countryOptions.find(option => option.title === filters.countries) || {}).value || null
        }
        this.pageData.selectedPage && (data.page = this.pageData.selectedPage)
        this.pageData.display && (data.item_per_page = this.pageData.display)
        this.sort.value[0] && (data.order_by = this.sort.value[0])
        this.sort.order[0] && (data.order_method = this.sort.order[0].replace(/^-/, ''))
        let response = await getReports(data, config)
        let reports = response.data.data.elements
        this.pageData.total = response.data.data.items_count
        this.reports = reports
      } catch (error) {
        throw error
      }
    },
    async searchDatas (init) {
      this.onSearch = true
      if (init) {
        this.init = init
        this.filter = init
      }
      await this.fetchReports(init)
      this.onSearch = false
    },
    reportDetail (report) {
      this.setModalAction({
        action: 'reportDetail',
        width: '900px',
        customStyles: {
          padding: '20px',
          margin: '20px auto',
          borderRadius: '0'
        },
        param: {
          data: report,
          func: {
            getReportTags: this.getReportTags,
            setFilter: this.setFilter
          }
        }
      })
    },
    getDateCompare (date) {
      let value = new Date() - date
      let compare = 0
      let list = [
        { title: '分鐘', value: 60 * 1000 },
        { title: '小時', value: 60 * 60 * 1000 },
        { title: '天', value: 24 * 60 * 60 * 1000 },
        { title: '週', value: 7 * 24 * 60 * 60 * 1000 },
        { title: '個月', value: 30 * 24 * 60 * 60 * 1000 },
        { title: '', value: 9 * 30 * 24 * 60 * 60 * 1000 }
      ]
      while (compare < list.length) {
        if (value < list[compare].value) {
          return (compare ? Math.floor(value / list[compare - 1].value) + list[compare - 1].title : '0分鐘') + '前'
        }
        compare++
      }
      return dateFormat(date, 'yyyy/MM/dd hh:mm')
    },
    getReportTags (report) {
      let tags = []
      let product = this.productOptions.find(option => option.title === report.product_name || option.value === report.product_code)
      if (product) {
        tags.push({
          title: product.title,
          filter: {
            category: product.category,
            product_code: product.value
          }
        })
      }
      if (report.countries && report.countries.length) {
        tags = [
          ...tags,
          ...report.countries.map(country => this.countryOptions.find(option => option.value === country)).filter(x => x).map(option => ({
            title: option.country.chinese_name,
            filter: {
              countries: option.title
            }
          }))
        ]
      }
      let _module = this.moduleOptions.find(option => option.value === report.module)
      if (_module) {
        tags.push({
          title: _module.title,
          filter: {
            module: _module.value
          }
        })
      }
      let year = this.yearOptions.find(option => option.value + '' === report.year + '')
      if (year) {
        tags.push({
          title: year.title,
          filter: {
            year: year.value
          }
        })
      }
      return tags
    },
    setFilter (filter) {
      this.filter = {
        ...filter
      }
      this.searchDatas(this.filter)
    },
    onWindowResize () {
      let containerWidth = this.$refs['report-main'].offsetWidth
      let reportBlockWidth = this.reportBlock.width + 25
      let reportCount = Math.floor(containerWidth / reportBlockWidth)
      let fillCount = reportCount - (this.reports.length - (Math.floor(this.reports.length / reportCount) * reportCount))
      this.reportBlock.fillCount = fillCount
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/main/report.vue